// extracted by mini-css-extract-plugin
export var container = "_bi-0";